import { useState } from "react";
import { useAuth } from "../../../contexts/Auth";
import { useMutation } from "react-query";
import { updateProfilePicture } from "../../../services/userApi";
import {
  Avatar,
  Box,
  Button,
  Flex,
  FormControl,
  FormLabel,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { EditIcon } from "@chakra-ui/icons";
import { trackEvent } from "../../../shared/analytics";
import CoverUploadModal from "../../../shared/components/CoverUploadModal";

const ProfilePictureForm = () => {
  const { authData, updateUser } = useAuth();
  const { isOpen, onToggle } = useDisclosure();
  const toast = useToast();
  const mutation = useMutation((profilePicture) => {
    return updateProfilePicture(profilePicture, "file");
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    // ...
  };

  const [previewUrl, setPreviewUrl] = useState("");

  const onCropSubmitted = (file, url) => {
    // setProfilePicture(file);
    setPreviewUrl(url);
    console.log(file);

    mutation
      .mutateAsync(file)
      .then(({ data }) => {
        trackEvent("profile_picture_updated");
        updateUser({ ...authData, profilePicture: data.profilePicture });
        toast({
          title: "Profile picture updated",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
        onToggle();
      })
      .catch(() => {
        setPreviewUrl("");
        toast({
          title: "Profile picture update failed",
          status: "error",
          duration: 3000,
          isClosable: true,
        });
      });
  };
  return (
    <Box p="3">
      <form onSubmit={handleSubmit}>
        <FormControl>
          <FormLabel>Profile Picture</FormLabel>
          <Flex alignItems="center">
            <Avatar
              size="xl"
              name={
                authData.userHandle ||
                `${authData.firstName} ${authData.lastName}`
              }
              src={previewUrl || authData.profilePicture}
            />
            <Button
              size="md"
              leftIcon={<EditIcon />}
              mx="3"
              variant="outline"
              onClick={() => onToggle()}
            >
              Change picture
            </Button>
            {/* <input
              ref={fileInputRef}
              type="file"
              hidden
              onChange={onFileInputChange}
              accept="image/jpeg"
            /> */}
            <CoverUploadModal
              onToggle={onToggle}
              isOpen={isOpen}
              onSubmit={onCropSubmitted}
              title="Upload a profile picture"
              aspectRatio={1}
              croppedCanvasConfig={{
                width: 1000,
                height: 1000,
                minWidth: 150,
                minHeight: 150,
                imageSmoothingEnabled: true,
                imageSmoothingQuality: "high",
              }}
            />
          </Flex>
        </FormControl>
      </form>
    </Box>
  );
};

export default ProfilePictureForm;
